module.exports = __webpack_public_path__ + "696416df.png";